import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var definitionListDescription = createRuntimeFn({defaultClassName:'definitionListDescription_definitionListDescription__1uk2fnd0',variantClassNames:{monospace:{true:'definitionListDescription_definitionListDescription_monospace_true__1uk2fnd1',false:'definitionListDescription_definitionListDescription_monospace_false__1uk2fnd2'}},defaultVariants:{monospace:false},compoundVariants:[]});

export { definitionListDescription };
//# sourceMappingURL=definitionListDescription.vanilla.mjs.map
